import { useCurrentClient } from "hooks/api/use-clients";

import { CampaignAttributes, useCampaigns } from "hooks/api/use-campaigns";

import { DEFAULT_PAGINATED_REQUEST_OPTIONS, PaginatedRequestOptions } from "types/pagination";

interface FetchTriggerProps {
  delayFetch: boolean;
  trigger: boolean;
}

export const useClientCampaigns = (
  options: PaginatedRequestOptions = DEFAULT_PAGINATED_REQUEST_OPTIONS,
  fetchTrigger?: FetchTriggerProps,
): CampaignAttributes[] => {
  const currentClient = useCurrentClient();

  const enabled = !fetchTrigger?.delayFetch || fetchTrigger.trigger;

  const { data } = useCampaigns(
    { clientId: currentClient.id, ...options },
    { enabled },
  );

  return data?.items ?? [];
};

export const useClientCampaignsInModal = (
  isModalOpen = false,
  options: PaginatedRequestOptions = DEFAULT_PAGINATED_REQUEST_OPTIONS,
) => useClientCampaigns(options, { delayFetch: true, trigger: isModalOpen });
